import { PaymentSchedule } from './paymentSchedule.model';

export class FormJ {
	constructor(
		_id?: number,
		_principal?: number,
		_customerId?: number,
		_customerName?: string,
		_icNumber?: string,
		_term?: number,
		_dateCreated?: Date,
		_lastPayment?: number,
		_paymentSchedule?: PaymentSchedule[],
		_receiptNumber?: string,
		_date?: Date,
		_scheme?: string,
		_businessId?: number,
		_branchId?: number,
		_licenseId?: number,
		_loanGroupId?: number,
		_version?: string,
		_dateStamped?: Date,
		_docusealId?: number,
		_docuseallink?: string
	);
	constructor(
		private _id: number,
		private _principal = 0,
		private _customerId: number,
		private _customerName: string,
		private _icNumber: string,
		private _term = 0,
		private _dateCreated: Date,
		private _lastPayment = 0,
		private _paymentSchedule: PaymentSchedule[],
		private _receiptNumber: string,
		private _date: Date,
		private _scheme: string,
		private _businessId: number,
		private _branchId: number,
		private _licenseId: number,
		private _loanGroupId?: number,
		private _version?: string,
		private _dateStamped?: Date,
		private _docusealId?: number,
		private _docuseallink?: string
	) {}

	set Id(id: number) {
		this._id = id;
	}
	get Id(): number {
		return this._id;
	}

	set Principal(principal: number) {
		this._principal = principal;
	}
	get Principal(): number {
		return this._principal;
	}

	set CustomerId(customerId: number) {
		this._customerId = customerId;
	}
	get CustomerId(): number {
		return this._customerId;
	}

	get CustomerName(): string {
		return this._customerName;
	}
	set CustomerName(value: string) {
		this._customerName = value;
	}

	get IcNumber(): string {
		return this._icNumber;
	}
	set IcNumber(value: string) {
		this._icNumber = value;
	}

	set Term(term: number) {
		this._term = term;
	}
	get Term(): number {
		return this._term;
	}

	set DateCreated(dateCreated: Date) {
		this._dateCreated = dateCreated;
	}
	get DateCreated(): Date {
		return this._dateCreated;
	}

	set Date(date: Date) {
		this._date = date;
	}
	get Date(): Date {
		return this._date;
	}

	set LastPayment(lastPayment: number) {
		this._lastPayment = lastPayment;
	}
	get LastPayment(): number {
		return this._lastPayment;
	}

	set PaymentSchedule(paymentSchedule: PaymentSchedule[]) {
		this._paymentSchedule = paymentSchedule;
	}
	get PaymentSchedule(): PaymentSchedule[] {
		return this._paymentSchedule;
	}

	set ReceiptNumber(receiptNumber: string) {
		this._receiptNumber = receiptNumber;
	}
	get ReceiptNumber(): string {
		return this._receiptNumber;
	}

	set Version(value: string) {
		this._version = value;
	}
	get Version(): string {
		return this._version;
	}

	set Scheme(value: string) {
		this._scheme = value;
	}
	get Scheme(): string {
		return this._scheme;
	}

	set BusinessId(value: number) {
		this._businessId = value;
	}
	get BusinessId(): number {
		return this._businessId;
	}

	set BranchId(value: number) {
		this._branchId = value;
	}
	get BranchId(): number {
		return this._branchId;
	}

	set LicenseId(value: number) {
		this._licenseId = value;
	}
	get LicenseId(): number {
		return this._licenseId;
	}

	set LoanGroupId(value: number) {
		this._loanGroupId = value;
	}
	get LoanGroupId(): number {
		return this._loanGroupId;
	}

	set DateStamped(value: Date) {
		this._dateStamped = value;
	}
	get DateStamped(): Date {
		return this._dateStamped;
	}

	set DocusealId(value: number) {
		this._docusealId = value;
	}
	get DocusealId(): number {
		return this._docusealId;
	}

	set DoccusealLink(value: string) {
		this._docuseallink = value;
	}
	get DoccusealLink(): string {
		return this._docuseallink;
	}
}

export interface IAPIFormJ {
	principal: number;
	customerid: number;
	term: number;
	data: {
		lastPayment: number;
		paymentSchedule: PaymentSchedule[];
		receiptNumber: string;
		stampDate: string;
		version: string;
	};
	scheme: string;
	businessLicenseId: number;
}

export interface Docuseal {
	id: number;
	expireAt: Date;
	openedAt: Date;
	createdAt: Date;
	updatedAt: Date;
	completedAt: Date;
	status: string;
	documentsUrl: string;
	customerLink: string;
	contactLink: string;
	link: string;
}
